module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av9-b9b6af20c2f671d33612ed9d2927cafb.jpg";